import SearchCard from "../Components/Shared/Layout/SearchCard";
import Axios from "axios";
import {useState, useEffect} from "react";
import { useSelector } from "react-redux";
import SearchInput from "../Components/NavBar/NavBarComponents/SearchInput";
import withLanguage from "../HOC/withLanguage";
import {useSearchParams} from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";

function SearchResult({language}) {
    const [institutionsData, setInstitutionsData] = useState({
        schools: [],
        centers: []
    });
    const [loading, setLoading] = useState(false);
    const [query] = useSearchParams();
    const queryValue = query.get("query"); 
    const isDual = query.get("isDual"); 

    const institutionFilter = useSelector(state => state.searchFilters.institutionType);
    const municipalityFilter = useSelector(state => state.searchFilters.municipality);
    const ownershipFilter = useSelector(state => state.searchFilters.ownership);


    useEffect(() => {
        const fetchData = async () => {
            if (!queryValue) {
                setInstitutionsData({ schools: [], centers: [] });
                return;
            }

            setLoading(true);

            try {
                const url = isDual ? `/api/institution_info/${queryValue.trim()}?dual_education__exact=true&` :`/api/institution_info/${queryValue.trim()}?`
                const searchResponse = await Axios.get(`${url}type__exact=${institutionFilter}&ownership__exact=${ownershipFilter}&municipality_id__exact=${municipalityFilter}`)

                if (!searchResponse.data.error) {
                    const responseJson = searchResponse.data;

                    const schools = responseJson ? responseJson?.filter(
                      (item) => item.type === "shkolle_profesionale",
                    ) : [];
                    const centers = responseJson? responseJson?.filter(
                      (item) => item.type === "qender_formimi",
                    ): [];


                    setInstitutionsData({ schools, centers });
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                if (error.response?.data) {
                    console.log("No Results:", error.response.data.error);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [queryValue, institutionFilter, municipalityFilter, ownershipFilter]);

    const renderInstitutionCards = (institutions, category) => (
        <div className="w-full my-7">
            <h2 className="text-[#DB3222] font-bold text-lg uppercase md:mt-0 mt-5">
                {category === 'shkolla' ? language.searchResultSchool : language.centers}
            </h2>
            {loading ? (
                <Skeleton variant="rectangular" width="90%" height={200} />
            ) : (
                institutions.map(item => {
                    return <SearchCard
                        key={item.id}
                        item={item}
                    />
})
            )}
        </div>
    );

    return (
        <div className="flex flex-col items-center m-5 xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem]">
            <SearchInput
                showFilters={true}
                value={queryValue}
                className="w-full bg-gray-100"
            />

            <div className="flex md:flex-row flex-col mt-8 w-full justify-between h-full">
                {(!institutionsData.schools.length && !institutionsData.centers.length && queryValue) && (
                    <div className="pt-5 font-bold text-lg">{language.noResults}</div>
                )}

                {(institutionsData.schools.length > 0 || institutionsData.centers.length > 0) && (
                    <div className="w-full">
                        {institutionsData.schools.length > 0 &&
                            renderInstitutionCards(institutionsData.schools, 'shkolla')
                        }

                        {institutionsData.centers.length > 0 &&
                            renderInstitutionCards(institutionsData.centers, 'qendra')
                        }
                    </div>
                )}
            </div>
        </div>
    );
}

export default withLanguage(SearchResult, "Search");